export default __webpack_public_path__ + "static/media/Tongue of the Vengeful Serpent.7f87aa12.jpg";